import type { JohnDeereMapLayerMetadata } from 'types/johnDeere';

export const MAPS_API = '/api/john-deere/maps';

export const DEFAULT_UNIT_ID = 'gal1ac-1';

export const CONNECTION_ERROR = 'Connection Error';

export const DEFAULT_METADATA: JohnDeereMapLayerMetadata[] = [
    { name: 'source', value: 'Exedy SVM' },
    { name: 'equipmentType', value: 'drone' },
    { name: 'operationType', value: 'application' }
];
